// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".progress-wrapper[data-v-08a4fc1a]{overflow:hidden}", "",{"version":3,"sources":["webpack://./resources/client/modules/settings/components/ImportItem.vue"],"names":[],"mappings":"AACA,mCAAoB,eACpB","sourcesContent":["\n.progress-wrapper { overflow: hidden; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
